import React from 'react';

const APP_URL = 'https://livingatlas.arcgis.com/esrifederal/';

const BrowseApp = () => {
    return (
        <div className="w-full h-screen">
            <iframe className="w-full h-full" src={APP_URL} />
        </div>
    );
};

export default BrowseApp;
